import { TRANSACTION_DELIVERY } from '@/types/transactionRequests';

export function getTransactionReviewDeliverySpeed(
  deliverySpeed: TRANSACTION_DELIVERY,
) {
  switch (deliverySpeed) {
    case 2:
      return 'Same Day (Book)';
    case 1:
      return 'Express (Wire)';
    default:
      return 'Standard (ACH)';
  }
}
